import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "../ui";
import type { ReactNode } from "react";
import { spacing } from "./settingsListDesign";
import { usePageBackSource } from "../layout/pageHeaderNavigation";

/** Member navigation appearance; the host owns destination, history and translated label. */
export function LayoutBackButton({ label, onBack }: { label: ReactNode; onBack: () => void }) {
  const inPageHeader = usePageBackSource(label, onBack);
  return <div className={inPageHeader ? "mq-layout-back mq-layout-back--in-header" : "mq-layout-back"} style={{ marginBottom: spacing.md }}>
    <Button type="text" icon={<ArrowLeftOutlined />} onClick={onBack} style={{ paddingInline: 0 }}>{label}</Button>
  </div>;
}
